import * as React from 'react';

import {Body} from '../typography/body';

import styles from './quote.module.css';

type Props = {
    statusLog: string;
};

export function SalesDocumentModalFooter(props: Props) {
    return (
        <div className={styles['modal-footer-container']}>
            <Body size='small' color='light'>
                {props.statusLog}
            </Body>
        </div>
    );
}
